import React, { useState } from "react";
import { App, Button, Col, Form, Input, Row, Upload } from "antd";
import {
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { ADD_IMAGE_VIEW } from "../../../apis/apis";

function AddImage(props) {
  const { notification, message } = App.useApp();

  const {
    set_add_image,
    list_refresh,
    set_list_refresh,
  } = props;

  const [errors, set_errors] = useState({});
  const [image, set_image] = useState("");
  const [image_api, set_image_api] = useState("");
  const [loading, setLoading] = useState(false);
  const [title, set_title] = useState("");
  const [imageError, setImageError] = useState("");

  const [form] = Form.useForm();

  const getBase64 = (img, callback) => {
    const reader = new FileReader();

    reader.addEventListener("load", () =>
      callback(reader.result)
    );

    reader.readAsDataURL(img);
  };

  const handleChange = async (info) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }

    set_image_api(info.file);

    if (info.file.status === "done") {
      const fileObj = info.file.originFileObj;

      set_image_api(fileObj);

      getBase64(fileObj, (url) => {
        setLoading(false);
        set_image(url);
      });
    } else if (info.file.status === "error") {
      setLoading(false);

      message.error("Upload failed. Please try again.");
    }
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? (
        <LoadingOutlined style={{ color: "#fff" }} />
      ) : (
        <PlusOutlined />
      )}

      <div style={{ marginTop: 8 }}>
        Upload
      </div>
    </button>
  );

  const onFinish = async () => {
    const formData = new FormData();

    formData.append("title", title);
    formData.append("image", image_api);

    try {
      const response = await ADD_IMAGE_VIEW(formData);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: "Image uploaded successfully",
        });

        set_add_image(false);

        list_refresh
          ? set_list_refresh(false)
          : set_list_refresh(true);

        setLoading(false);
      } else {
        setLoading(false);

        set_errors(response?.data?.errors || {});
      }
    } catch (error) {
      message.error("Something went wrong!");

      console.error(error);
    }
  };

  return (
    <div style={{ padding: 16 }}>

      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: 20 }}
      >
        <Col>
          <h2>Add Image</h2>
        </Col>

        <Col>
          <Button onClick={() => set_add_image(false)}>
            Back To List
          </Button>
        </Col>
      </Row>

      <Form
        layout="vertical"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        validateTrigger="onSubmit"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Form.Item label="Image">
              <Upload
                name="image"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                style={{
                  width: "100%",
                  height: "32vh",
                  overflow: "hidden",
                }}
                beforeUpload={(file) => {
                  const isJpgOrPng =
                    file.type === "image/jpeg" ||
                    file.type === "image/png" ||
                    file.type === "image/jpg";

                  const isLt512KB =
                    file.size <= 512 * 1024;

                  if (!isJpgOrPng) {
                    set_image_api("");
                    set_image("");

                    setImageError(
                      "Only JPG, JPEG and PNG files are allowed."
                    );

                    return false;
                  }

                  if (!isLt512KB) {
                    set_image_api("");
                    set_image("");

                    setImageError(
                      "Image must be smaller than or equal to 512KB."
                    );

                    return false;
                  }

                  getBase64(file, (url) =>
                    set_image(url)
                  );

                  set_image_api(file);

                  setImageError("");

                  return false;
                }}
                onChange={handleChange}
              >
                {image ? (
                  <img
                    src={image}
                    alt="preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>

              {errors?.image && (
                <span style={{ color: "red" }}>
                  {errors?.image}
                </span>
              )}

              {imageError && (
                <span
                  style={{
                    color: "red",
                    display: "block",
                    marginTop: 8,
                  }}
                >
                  {imageError}
                </span>
              )}

              <p
                style={{
                  color: "#65e7c4",
                  marginTop: "10px",
                }}
              >
                Note - Image must be smaller than or
                equal to 512KB.
              </p>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={16} lg={16}>
            <Form.Item label="Title">
              <Input
                placeholder="Enter image title"
                value={title}
                onChange={(e) =>
                  set_title(e.target.value)
                }
              />

              {errors?.title && (
                <span style={{ color: "red" }}>
                  {errors?.title}
                </span>
              )}
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
            >
              Upload
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default AddImage;